import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ErrorHandlerService } from '@core/services/error-handler.service';
import { SessionExpiredService } from '../services/session-expired.service';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
    const errorHandler = inject(ErrorHandlerService);
    const sessionExpired = inject(SessionExpiredService);

    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            const isSilentError = req.headers.has('X-Silent-Error') || req.url.includes('/invoices/');

            let apiError = null;
            if (!isSilentError) {
                const shouldLogout = error.error?.message_code === 'INVALID_TOKEN' || error.error?.shouldLogout === true;

                if (shouldLogout) {
                    apiError = { message: '', timestamp: new Date(), shouldLogout: true };
                    sessionExpired.show();
                } else {
                    apiError = errorHandler.handleError(error);
                }
            }

            return throwError(() => apiError || error);
        }),
    );
};
